export const appName = 'NUSO Quoting'

export const defaults = {
  appName: 'NUSO Quoting',
  production: true,
  showDebug: false,
  statusPageIoEmbedUrl: 'https://cy964sjcc8dg.statuspage.io/embed/frame'
}